<template>

        <!-- 版权信息 -->
        <div class="footer" v-html="config.copyrightContent">
        </div>

</template>

<script>
export default {
  props: [
    'i18n',
    'config',
  ],
  data: function data() {
    return {
    }
  },
  created: function created() {
  },
  mounted: function mounted() {
  },
  methods:{
  }
}
</script>
